import { useSelector } from "react-redux";
import { useMemo } from "react";
import { NotificationEmail } from "../../../domain/user/notification/NotificationEmail";
import { State } from "../../../state/store";

export const useNotificationEmailList = (): NotificationEmail[] => {
    const responseJsonArray = useSelector((state: State) => state.user.notifications);

    // コンポーネントでのuseEffect無限ループ対策
    const notificationEmailArray = useMemo(() => (
        responseJsonArray.map(responseJson =>
            NotificationEmail.from(responseJson.email))
    ), [responseJsonArray]);

    return notificationEmailArray;
};
